import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { EnvironmentService } from '@offconon/shared/utils/services/environment';
import { SiteLanguageService } from '@offconon/shared/utils/services/site-language';

import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private authenticationService = inject(AuthService);
  private siteLanguageService = inject(SiteLanguageService);

  private environmentService = inject(EnvironmentService);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const currentUser = this.authenticationService.currentUserValue;
    const isLoggedIn = currentUser && currentUser.jwt_token;
    const isApiUrl =
      request.url.startsWith(this.environmentService.environment.adminApi) ||
      request.url.startsWith(this.environmentService.environment.coreApi);
    let authHeader = {};

    if (isLoggedIn && isApiUrl) {
      authHeader = {
        Authorization: `Bearer ${currentUser.jwt_token}`,
      };
    }
    request = request.clone({
      setHeaders: {
        ...authHeader,
        LanguageId: this.siteLanguageService.actualSiteLanguageId().toString(),
      },
    });

    return next.handle(request);
  }
}
